import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { resolve } from 'inversify-react';

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ControllerProps } from 'src/router';
import { DialogService } from 'src/core/services/ui/dialog.service';
import { UserListView } from './user-list.view';
import { UserListDataService } from './user-list.data';

@observer
export class UserListController extends React.Component<ControllerProps<any>, {}> {
	@observable
	dataService: UserListDataService;

	@resolve
	dialogService: DialogService;

	@resolve
	toast: ToastNotifications;

	constructor(props: Readonly<ControllerProps<any>>) {
		super(props);
	}

	componentDidMount() {
		this.loadData();
	}

	private loadData(): void {
		this.dataService = UserListDataService.make();

		this.props.setBusy(true);
		this.dataService.addFilter('isRole', 'eq', false);
		this.dataService.addFilter('isDeleted', 'eq', false);
		this.dataService.addSorting('userName', 'asc', true);
		this.dataService.load(query => query)
			.catch((error) => {
				this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
			})
			.then(() => {
				this.props.setBusy(false);
			});
	}

	handleItemDoubleClick = (item: UserSummary): void => {
		this.props.history.push(`/general/users/${item == null ? 'new' : item.id}`);
	};

	render(): JSX.Element {
		if (this.dataService == null) {
			return null;
		}

		return (
			<UserListView
				model={this.dataService}
				setBusy={this.props.setBusy}
				onItemDoubleClicked={this.handleItemDoubleClick}
				{...this.props}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/users/list/user-list.controller.tsx